import { HallmapTable } from 'entities/hallmap';
import Konva from 'konva';
import Table from './table/table';

export type TSize = 'S' | 'M' | 'L' | 'XL';

export interface GameConstructorParams {
	onReady?: () => void;
	onMoveTable?: (table: Table) => void;
	onClickTable?: (table: Table) => void;
	onDblClickTable?: (table: Table) => void;
	onBeforeSelectTable?: () => void;
	onSelectTable?: (table: Table) => void;
	onDeselectTable?: (table: Table) => void;
	onConflictTable?: (table: Table) => void;
	stage: Konva.Stage;
	tables: HallmapTable[];
}

type emptyIcon = '';
export type icon = 'iconTimer' | 'iconPerson' | emptyIcon | string;

export type position = {
	x: number,
	y: number
}

export enum DiagramState {
	hide = 0,
	showFront = 1,
	showBoth = 2,
}